import { viewer as view } from '/@/hooks/Cesium/use-cesium-map'
import * as Cesium from 'cesium'

// 精简版掩膜管理器 - 仅边框高亮，区域外变暗
const BorderMaskManager = {
  // 存储创建的图元和实体
  maskPrimitives: [],
  maskEntities: [],
  maskPolygons: [],
  currentDataSource: null,
  originalGlobeColor: null,

  add3DAreA: function (geojson) {
    const arr = []
    geojson.features[0].geometry.coordinates[0][0].forEach(item => {
      arr.push(item[0])
      arr.push(item[1])
    })
    const maskspoint = Cesium.Cartesian3.fromDegreesArray(arr)
    const polygonWithHole = new Cesium.PolygonGeometry({
      polygonHierarchy: new Cesium.PolygonHierarchy(
        Cesium.Cartesian3.fromDegreesArray([73.0, 53.0, 73.0, 0.0, 135.0, 0.0, 135.0, 53.0]),
        [new Cesium.PolygonHierarchy(Cesium.Cartesian3.fromDegreesArray(arr))]
      )
    })

    const geometry = Cesium.PolygonGeometry.createGeometry(polygonWithHole)
    const instances = []
    instances.push(new Cesium.GeometryInstance({
      geometry: geometry,
      attributes: {
        color: Cesium.ColorGeometryInstanceAttribute.fromColor(Cesium.Color.fromCssColorString('#1e2426'))
      }
    }))
    function addRect (instances, left, down, right, up) {
      const rectangleGeom = new Cesium.RectangleGeometry({
        rectangle: Cesium.Rectangle.fromDegrees(left, down, right, up)
      })
      const geometry = Cesium.RectangleGeometry.createGeometry(rectangleGeom) // ✅ 预计算
      instances.push(new Cesium.GeometryInstance({
        geometry: geometry,
        attributes: {
          color: Cesium.ColorGeometryInstanceAttribute.fromColor(Cesium.Color.fromCssColorString('#1e2426'))
        }
      }))
    }
    addRect(instances, -180.0, -90.0, 73.0, 90.0)
    addRect(instances, 135.0, -90.0, 180.0, 90.0)
    addRect(instances, 73.0, 53.0, 135.0, 90.0)
    addRect(instances, 73.0, -90.0, 135.0, 0.0)
    const maskPrimitives = new Cesium.Primitive({
      geometryInstances: instances,
      appearance: new Cesium.PerInstanceColorAppearance({
        flat: true,
        translucent: false
      }),
      asynchronous: false
    })
    view.scene.primitives.add(maskPrimitives)
    this.maskPrimitives.push(maskPrimitives)
    const entity3 = new Cesium.Entity({
      name: '动态立体墙',
      wall: {
        positions: maskspoint,
        maximumHeights: maskspoint.map((res) => {
          // return 600;
          return 0
        }),
        minimumHeights: maskspoint.map((res) => {
          return -600
        }),
        material: Cesium.Color.fromCssColorString('#2a373c'),
      },
    })
    view.entities.add(entity3)
    this.maskEntities.push(entity3)
    return { maskPrimitives, entity: entity3 }
  },

  /**
   * 创建边框高亮掩膜
   * @param {string} geoJsonUrl - GeoJSON文件路径
   * @param {Object} options - 配置选项
   */
  createBorderMask: function (geoJsonUrl, options = {}) {
    const defaultOptions = {
      borderColor: Cesium.Color.YELLOW, // 边框颜色
      borderWidth: 5, // 边框宽度
      borderOpacity: 0.8, // 边框透明度
      maskOpacity: 0.7, // 区域外掩膜透明度
      maskColor: Cesium.Color.BLACK, // 区域外掩膜颜色
      enableGlow: true, // 是否启用发光效果
      glowPower: 0.1 // 发光强度
    }

    const config = { ...defaultOptions, ...options }

    return new Promise((resolve, reject) => {
      // 清除之前的掩膜
      this.removeBorderMask()

      // 获取viewer实例
      const viewer = view || this._getViewer()

      // 保存原始地球颜色
      this.originalGlobeColor = viewer.scene.globe.baseColor.clone()

      // 1. 加载区域GeoJSON
      Cesium.GeoJsonDataSource.load(geoJsonUrl, {
        // 设置GeoJSON加载时的样式，将多边形填充设为透明
        stroke: config.borderColor, // 边框颜色
        strokeWidth: config.borderWidth, // 边框宽度
        fill: Cesium.Color.TRANSPARENT, // 将填充设为透明
        strokeOpacity: config.borderOpacity // 边框透明度
      })
        .then(dataSource => {
          viewer.dataSources.add(dataSource)
          this.currentDataSource = dataSource

          // 2. 为每个区域创建掩膜和高亮边框
          this._processRegions(dataSource, config)

          // 3. 调整视角
          //   this._zoomToRegion(dataSource)

          resolve({
            dataSource: dataSource,
            primitives: this.maskPrimitives,
            entities: this.maskEntities,
            polygons: this.maskPolygons
          })
        })
        .catch(reject)
    })
  },

  /**
   * 处理区域数据，创建掩膜和边框
   */
  _processRegions: function (dataSource, config) {
    const viewer = view || this._getViewer()
    const entities = dataSource.entities.values

    // 确保所有实体的多边形填充为透明
    entities.forEach((entity) => {
      if (entity.polygon) {
        // 设置多边形填充为透明
        entity.polygon.material = Cesium.Color.TRANSPARENT
        // 如果有轮廓线，也设为透明（因为我们后面会自己添加边框）
        if (entity.polygon.outline) {
          entity.polygon.outline = false
        }
        // 确保多边形不可见
        entity.polygon.show = true // 保持show为true，但材质透明
      }
    })

    // 首先创建一个覆盖全球的黑色半透明层
    // this._createGlobalMaskLayer(config)

    entities.forEach((entity, index) => {
      if (entity.polygon) {
        const hierarchy = entity.polygon.hierarchy.getValue(Cesium.JulianDate.now())

        if (hierarchy && hierarchy.positions) {
          // 方法1：在全局掩膜层上挖洞（显示区域）
          this._createRegionHole(hierarchy.positions, config)

          // 方法2：创建高亮边框
          this._createHighlightBorder(hierarchy.positions, config)

          // 方法3：添加发光效果（可选）
          if (config.enableGlow) {
            this._addGlowEffect(hierarchy.positions, config.borderColor)
          }
        }
      }
    })
  },

  /**
   * 创建全局掩膜层 - 覆盖整个地球的黑色半透明层
   */
  _createGlobalMaskLayer: function (config) {
    const viewer = view || this._getViewer()

    // 创建一个覆盖整个地球的矩形
    const rectangle = Cesium.Rectangle.fromDegrees(-180, -90, 180, 90)

    // 使用RectanglePrimitive创建矩形图元
    const rectanglePrimitive = new Cesium.Primitive({
      geometryInstances: new Cesium.GeometryInstance({
        geometry: new Cesium.RectangleGeometry({
          rectangle: rectangle,
          vertexFormat: Cesium.PerInstanceColorAppearance.VERTEX_FORMAT
        }),
        id: 'global-mask-layer',
        attributes: {
          color: Cesium.ColorGeometryInstanceAttribute.fromColor(
            config.maskColor.withAlpha(config.maskOpacity)
          )
        }
      }),
      appearance: new Cesium.PerInstanceColorAppearance({
        translucent: true,
        flat: true
      }),
      asynchronous: false
    })

    viewer.scene.primitives.add(rectanglePrimitive)
    this.maskPrimitives.push(rectanglePrimitive)
  },

  /**
   * 创建区域洞 - 在全局掩膜层上挖洞显示区域
   * 使用Stencil技术来创建洞
   */
  _createRegionHole: function (positions, config) {
    const viewer = view || this._getViewer()

    // 创建一个与区域形状相同的多边形，但使用深度测试和模板缓冲区来创建洞
    const polygonGeometry = new Cesium.PolygonGeometry({
      polygonHierarchy: new Cesium.PolygonHierarchy(positions),
      perPositionHeight: true,
      vertexFormat: Cesium.PerInstanceColorAppearance.VERTEX_FORMAT
    })

    const regionPrimitive = new Cesium.Primitive({
      geometryInstances: new Cesium.GeometryInstance({
        geometry: polygonGeometry,
        id: 'region-hole-' + Date.now(),
        attributes: {
          color: Cesium.ColorGeometryInstanceAttribute.fromColor(
            Cesium.Color.TRANSPARENT
          )
        }
      }),
      appearance: new Cesium.PerInstanceColorAppearance({
        translucent: true,
        flat: true,
        renderState: {
          depthTest: {
            enabled: true
          },
          stencilTest: {
            enabled: true,
            frontFunction: Cesium.StencilFunction.NOT_EQUAL,
            frontOperation: {
              fail: Cesium.StencilOperation.KEEP,
              zFail: Cesium.StencilOperation.KEEP,
              zPass: Cesium.StencilOperation.REPLACE
            },
            backFunction: Cesium.StencilFunction.NOT_EQUAL,
            backOperation: {
              fail: Cesium.StencilOperation.KEEP,
              zFail: Cesium.StencilOperation.KEEP,
              zPass: Cesium.StencilOperation.REPLACE
            },
            reference: 1,
            mask: 0xFF
          },
          colorMask: {
            red: false,
            green: false,
            blue: false,
            alpha: false
          }
        }
      }),
      asynchronous: false
    })

    viewer.scene.primitives.add(regionPrimitive)
    this.maskPrimitives.push(regionPrimitive)
  },

  /**
   * 创建高亮边框
   */
  _createHighlightBorder: function (positions, config) {
    const viewer = view || this._getViewer()

    // 创建边框实体
    const borderEntity = viewer.entities.add({
      polyline: {
        positions: positions,
        width: config.borderWidth,
        material: config.borderColor.withAlpha(config.borderOpacity),
        clampToGround: true
      }
    })

    this.maskEntities.push(borderEntity)
  },

  /**
   * 添加发光效果
   */
  _addGlowEffect: function (positions, color) {
    const viewer = view || this._getViewer()

    const glowEntity = viewer.entities.add({
      polyline: {
        positions: positions,
        width: 20,
        material: new Cesium.PolylineGlowMaterialProperty({
          glowPower: 0.2,
          color: color.withAlpha(0.3)
        }),
        clampToGround: true
      }
    })

    this.maskEntities.push(glowEntity)
  },

  /**
   * 移除边框掩膜
   */
  removeBorderMask: function () {
    const viewer = view || this._getViewer()

    // 移除掩膜图元
    this.maskPrimitives.forEach(primitive => {
      viewer.scene.primitives.remove(primitive)
    })

    // 移除边框实体
    this.maskEntities.forEach(entity => {
      viewer.entities.remove(entity)
    })

    // 移除区域多边形实体
    this.maskPolygons.forEach(entity => {
      viewer.entities.remove(entity)
    })

    // 移除数据源
    if (this.currentDataSource) {
      viewer.dataSources.remove(this.currentDataSource)
    }

    // 恢复地球颜色
    if (this.originalGlobeColor) {
      viewer.scene.globe.baseColor = this.originalGlobeColor
    }

    // 清除存储
    this.maskPrimitives = []
    this.maskEntities = []
    this.maskPolygons = []
    this.currentDataSource = null

    console.log('边框掩膜已移除')
  },

  /**
   * 更新边框颜色
   */
  updateBorderColor: function (color) {
    this.maskEntities.forEach(entity => {
      if (entity.polyline) {
        entity.polyline.material = color
      }
    })
  },

  /**
   * 更新边框宽度
   */
  updateBorderWidth: function (width) {
    this.maskEntities.forEach(entity => {
      if (entity.polyline) {
        entity.polyline.width = width
      }
    })
  },

  /**
   * 更新掩膜透明度
   */
  updateMaskOpacity: function (opacity) {
    this.maskPrimitives.forEach(primitive => {
      // 更新全局掩膜层的透明度
      if (primitive.id === 'global-mask-layer') {
        const geometryInstance = primitive.geometryInstances
        if (geometryInstance && geometryInstance.attributes.color) {
          const color = geometryInstance.attributes.color.value
          color.alpha = opacity
        }
      }
    })
  },

  /**
   * 调整视角到区域
   */
  _zoomToRegion: function (dataSource) {
    const viewer = view || this._getViewer()

    if (dataSource.entities.values.length > 0) {
      viewer.flyTo(dataSource.entities, {
        duration: 2
      })
    }
  },

  /**
   * 获取viewer实例
   */
  _getViewer: function () {
    if (!view) {
      throw new Error('请先初始化Cesium viewer并赋值给window.viewer')
    }
    return view
  }
}

// 导出到全局
export default BorderMaskManager
